import { FileDown } from "lucide-react";
import { formatDate } from "./../ui/formatDate";
export function ExportPaymentPDF({
  paymentData,
  clientName,
  paymentSummaryCard,
}) {
  const generatePrint = () => {
    // Create a new window for printing
    const printWindow = window.open("", "", "height=600,width=800");

    // HTML content for printing with updated UI

    let printContent = `
      <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Payment Statement</title>
    <style>
        @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");

        /* Page Margin settings for printing */
       @page {
    size: landscape;  /* Set to landscape mode */
    margin-left: 0;    /* Remove left margin */
    margin-right: 0;   /* Remove right margin */
    margin-top: 10mm;  /* Optional: You can keep a small margin at the top */
    margin-bottom: 10mm; /* Optional: Keep a small margin at the bottom */
}


        body {
            font-family: 'Roboto', Arial, sans-serif;
            font-size: 8px;
            color: #333;
            margin: 0;
            padding: 5px;
            background-color: #f8f9fa;
        }

        .container {
            max-width: 1000px;
            margin: 0 auto;
            background-color: #ffffff;
            box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            overflow: hidden;
        }

        .page-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 7px;
            background-color: #004C8F;
            color: white;
        }

        .bank-logo {
            font-size: 20px;
            font-weight: 500;
        }

        .page-info {
            font-size: 8px;
        }

        .content {
            padding: 2px;
        }

        .account-holder-box {
            background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
            border-radius: 8px;
            padding: 5px;
            margin-bottom: 10px;
            color: #333;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .account-details {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 2px;
            margin-bottom: 10px;
            background-color: #f1f3f5;
            padding: 7px;
            border-radius: 8px;
        }

        .account-details div {
            display: flex;
            gap: 2px;
        }

        .account-details strong {
            min-width: 120px;
            color: #004C8F;
        }

        .table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            margin-top: 10px;
            font-size: 9px;
            table-layout: fixed;
        }

        .table th, .table td {
            border: 1px solid #e9ecef;
            padding: 4px;
            text-align: left;
            word-wrap: break-word;
        }

        .table th {
            background-color: #004C8F;
            color: white;
            font-weight: 300;
            text-transform: uppercase;
        }

        .table tr:nth-child(even) {
            background-color: #f8f9fa;
        }

        .table tr:hover {
            background-color: #e9ecef;
        }

        /* Adjust column widths */
        .table th:nth-child(1), .table td:nth-child(1) {
            width: 10%;
        }

        .table th:nth-child(2), .table td:nth-child(2) {
            width: 10%;
        }

        .table th:nth-child(3), .table td:nth-child(3) {
            width: 10%;
        }

        .table th:nth-child(4), .table td:nth-child(4) {
            width: 10%;
        }

        .table th:nth-child(5), .table td:nth-child(5) {
            width: 10%;
        }

        .table th:nth-child(6), .table td:nth-child(6) {
            width: 10%;
        }

        .table th:nth-child(7), .table td:nth-child(7) {
            width: 10%;
        }

        .table th:nth-child(8), .table td:nth-child(8) {
            width: 10%;
        }

        .table th:nth-child(9), .table td:nth-child(9) {
            width: 10%;
        }

        .table th:nth-child(10), .table td:nth-child(10) {
            width: 10%;
        }

        /* New column widths */
        .table th:nth-child(11), .table td:nth-child(11) {
            width: 8%; /* Remarks column */
        }

        .table th:nth-child(12), .table td:nth-child(12) {
            width: 8%; /* Narration column */
        }
        .table th:nth-child(13), .table td:nth-child(13) {
            width: 8%; /* Narration column */
        }

        .summary-section {
            margin-top: 10px;
            background-color: #e9ecef;
            padding: 10px;
            border-radius: 4px;
        }

        .summary-section strong {
            color: #004C8F;
            font-size: 16px;
            display: block;
            margin-bottom: 8px;
        }

        .footer {
            margin-top: 20px;
            font-size: 11px;
            color: #6c757d;
            text-align: center;
            padding: 15px;
            background-color: #f1f3f5;
            border-radius: 8px;
        }

        .disclaimer {
            margin-top: 15px;
            font-size: 11px;
            font-style: italic;
            text-align: center;
            color: #6c757d;
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="page-header">
            <div class="bank-logo">Payment Statement</div>
            <div class="page-info">Page No: 1</div>
        </div>

        <div class="content">
            <div class="account-holder-box">
                <strong>${clientName}</strong><br>
                
                
                Branch: Main Branch
            </div>

            <div class="account-details">
                <div><strong>Account Type:</strong> Regular</div>
                <div><strong>Statement Period:</strong> ${new Date().toLocaleDateString()}</div>
                <div><strong>Currency:</strong> INR</div>
                <div><strong>Generated On:</strong> ${new Date().toLocaleDateString()}</div>
            </div>

            <table class="table">
                <thead>
                    <tr>
                        <th>Time Stamp</th>
                        <th>Date</th>
                        <th>Sold Amount</th>
                        <th>Received</th>
                        <th>Transfer In</th>
                        <th>Transfer Out</th>
                        <th>Transfer By</th>
                        <th>Transfer To</th>
                        <th>Balance</th>
                        <th>Payment Type</th>
                        <th>Mode</th>
                        <th>Remarks</th> <!-- New column -->
                        <th>Narration</th> <!-- New column -->
                    </tr>
                </thead>
                <tbody>
                    ${paymentData
                      .map(
                        (payment) => `
                    <tr>
                        <td>${formatDate(payment.createdAt) || "-"}</td>
                        <td>${payment.date || "-"}</td>
                        <td>₹${payment.soldAmount.toFixed(2) || "-"}</td>
                        <td>₹${payment.receivedAmount.toFixed(2) || "-"}</td>
                        <td>₹${payment.transferIn.toFixed(2) || "-"}</td>
                        <td>₹${payment.transferOut.toFixed(2) || "-"}</td>
                        <td>${payment.sentBy || "-"}</td>
                        <td>${payment.sentTo || "-"}</td>
                        <td class="text-center">
  <!-- Check if the balance is zero or negative -->
  ${
    payment.currentBalance === 0
      ? "-"
      : payment.currentBalance < 0
      ? `
    <div style="color: #28a745; font-weight: bold;">
      ${Math.abs(payment.currentBalance).toFixed(2)} 
      <span style="font-size: 10px;">Adv.</span>
    </div>`
      : `₹${payment.currentBalance.toFixed(2)}`
  }
</td>


                        <td>${payment.orderPaymentType || "-"}</td>
                        <td>${payment.paymentMode || "-"}</td>
                        <td>${payment.remarks || "-"}</td> <!-- New column -->
                        <td>${payment.narration || "-"}</td> <!-- New column -->
                    </tr>`
                      )
                      .join("")}
                </tbody>
            </table>

            <div class="summary-section">
                <strong>STATEMENT SUMMARY</strong>
                <div>Opening Balance: ₹${
                  paymentData[0]?.currentBalance.toFixed(2) || "0.00"
                }</div>
                <div>Total Credits: ${
                  paymentData.filter((p) => p.transferIn > 0).length
                }</div>
                <div>Total Debits: ${
                  paymentData.filter((p) => p.transferOut > 0).length
                }</div>
                <div>Closing Balance: ₹${
                  paymentData[paymentData.length - 1]?.currentBalance.toFixed(
                    2
                  ) || "0.00"
                }</div>
            </div>

            <div class="disclaimer">
                This is a computer-generated statement and does not require a signature.
            </div>

            <!-- <div class="footer">
                For any queries, please contact our customer support at support@myapp.com<br>
                MyApp Financial Services Ltd. | Registered Office: Financial District, City - 500032
            </div> -->
        </div>
    </div>
</body>
</html>






      `;

    // Write the HTML content to the print window
    printWindow.document.write(printContent);
    printWindow.document.close();

    // Wait for the document to fully load, then print
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
      }, 250); // Add a slight delay before calling print()
    };
  };

  return (
    <button
      onClick={generatePrint}
      className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-3 text-xs rounded-lg flex items-center gap-2 transition duration-300 ease-in-out transform hover:scale-105 shadow-lg"
    >
      <FileDown size={16}/>
      Print Statement
    </button>
  );
}

// Contact PersonName: ${paymentSummaryCard?.contactPerson || "N/A"}<br></br>
//hdfc bank styling ------------------------heloo -----------------------------

// let printContent = `
// <html>
// <head>
//   <title>Payment Statement</title>
//   <style>
//     body {
//       font-family: Arial, sans-serif;
//       font-size: 12px;
//       color: #000;
//       margin: 20px;
//       background: white;
//     }
//     .page-header {
//       display: flex;
//       justify-content: space-between;
//       margin-bottom: 20px;
//     }
//     .bank-logo {
//       font-size: 24px;
//       font-weight: bold;
//       color: #004C8F;
//     }
//     .page-info {
//       text-align: right;
//       font-size: 11px;
//     }
//     .account-holder-box {
//       background: #FFE4E1;
//       border: 1px solid #000;
//       padding: 15px;
//       margin-bottom: 20px;
//     }
//     .account-details {
//       display: grid;
//       grid-template-columns: auto auto;
//       gap: 10px;
//       margin-bottom: 20px;
//     }
//     .account-details div {
//       display: flex;
//       gap: 10px;
//     }
//     .account-details strong {
//       min-width: 120px;
//     }
//     .statement-period {
//       margin: 15px 0;
//       font-weight: bold;
//     }
//     .table {
//       width: 100%;
//       border-collapse: collapse;
//       margin-top: 20px;
//       font-size: 11px;
//     }
//     .table th, .table td {
//       border: 1px solid #ddd;
//       padding: 10px;
//       text-align: left;
//     }
//     .table th {
//       background-color: #2980b9;
//       color: white;
//       font-weight: bold;
//     }
//     .table td {
//       text-align: right;
//       font-size: 12px;
//     }
//     .table td:first-child {
//       text-align: left;
//     }
//     .summary-section {
//       margin-top: 20px;
//       border-top: 1px solid #000;
//       padding-top: 10px;
//     }
//     .footer {
//       margin-top: 30px;
//       font-size: 9px;
//       color: #666;
//       text-align: center;
//     }
//     .disclaimer {
//       margin-top: 20px;
//       font-size: 10px;
//       font-style: italic;
//       text-align: center;
//     }
//   </style>
// </head>
// <body>
//   <div class="page-header">
//     <div class="bank-logo">Kiyo Internation Payment Statement</div>
//     <div class="page-info">Page No: 1</div>
//   </div>

//   <div class="account-holder-box">
//     <strong>${clientName}</strong><br>
//     Account ID: ${paymentData[0]?.accountId || "N/A"}<br>
//     Branch: Main Branch
//   </div>

//   <div class="account-details">
//     <div><strong>Account Type:</strong> Regular</div>
//     <div><strong>Statement Period:</strong> ${new Date().toLocaleDateString()}</div>
//     <div><strong>Currency:</strong> INR</div>
//     <div><strong>Generated On:</strong> ${new Date().toLocaleDateString()}</div>
//   </div>

//   <table class="table" style="width: 90%; margin: 10px auto; border-collapse: collapse;">
// <thead>
// <tr>
// <th style="padding: 6px 10px; text-align: left;">Date</th>
// <th style="padding: 6px 10px; text-align: left;">Sold Amount</th>
// <th style="padding: 6px 10px; text-align: left;">Received</th>
// <th style="padding: 6px 10px; text-align: left;">Transfer In</th>
// <th style="padding: 6px 10px; text-align: left;">Transfer Out</th>
// <th style="padding: 6px 10px; text-align: left;">Transfer By</th>
// <th style="padding: 6px 10px; text-align: left;">Transfer To</th>
// <th style="padding: 6px 10px; text-align: left;">Balance</th>
// <th style="padding: 6px 10px; text-align: left;">Payment Type</th>
// <th style="padding: 6px 10px; text-align: left;">Mode</th>
// </tr>
// </thead>
// <tbody>
// ${paymentData
// .map(
//   (payment) => `
// <tr>
//   <td style="padding: 6px 10px; text-align: left;">${payment.date}</td>
//   <td style="padding: 6px 10px; text-align: right;">₹${payment.soldAmount.toFixed(2)}</td>
//   <td style="padding: 6px 10px; text-align: right;">₹${payment.receivedAmount.toFixed(2)}</td>
//   <td style="padding: 6px 10px; text-align: right;">₹${payment.transferIn.toFixed(2)}</td>
//   <td style="padding: 6px 10px; text-align: right;">₹${payment.transferOut.toFixed(2)}</td>
//   <td style="padding: 6px 10px; text-align: left;">${payment.sentBy || "NA"}</td>
//   <td style="padding: 6px 10px; text-align: left;">${payment.sentTo || "NA"}</td>
//   <td style="padding: 6px 10px; text-align: right;">₹${payment.currentBalance.toFixed(2)}</td>
//   <td style="padding: 6px 10px; text-align: left;">${payment.orderPaymentType}</td>
//   <td style="padding: 6px 10px; text-align: left;">${payment.paymentMode || "N/A"}</td>
// </tr>`
// )
// .join('')}
// </tbody>
// </table>

//   <div class="summary-section">
//     <strong>STATEMENT SUMMARY</strong><br>
//     Opening Balance: ₹${paymentData[0]?.currentBalance.toFixed(2) || "0.00"}<br>
//     Total Credits: ${paymentData.filter((p) => p.transferIn > 0).length}<br>
//     Total Debits: ${paymentData.filter((p) => p.transferOut > 0).length}<br>
//     Closing Balance: ₹${paymentData[paymentData.length - 1]?.currentBalance.toFixed(2) || "0.00"}
//   </div>

//   <div class="disclaimer">
//     This is a computer-generated statement and does not require a signature.
//   </div>

//   <div class="footer">
//     For any queries, please contact our customer support at support@myapp.com<br>
//     MyApp Financial Services Ltd. | Registered Office: Financial District, City - 500032
//   </div>
// </body>
// </html>
// `;

// -------------------------end ------------------------------

// let printContent = `
//       <!DOCTYPE html>
// <html lang="en">
// <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>Payment Statement</title>
//     <style>
//         @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap");

//         body {
//             font-family: 'Roboto', Arial, sans-serif;
//             font-size: 12px; /* Reduced font size */
//             color: #333;
//             margin: 0;
//             padding: 10px; /* Reduced padding */
//             background-color: #f8f9fa;
//         }

//         .container {
//             max-width: 1000px;
//             margin: 0 auto;
//             background-color: #ffffff;
//             box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Reduced shadow */
//             border-radius: 8px;
//             overflow: hidden;
//         }

//         .page-header {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             padding: 10px 15px; /* Reduced padding */
//             background-color: #004C8F;
//             color: white;
//         }

//         .bank-logo {
//             font-size: 20px; /* Reduced font size */
//             font-weight: 700;
//         }

//         .page-info {
//             font-size: 12px; /* Reduced font size */
//         }

//         .content {
//             padding: 15px; /* Reduced padding */
//         }

//         .account-holder-box {
//             background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
//             border-radius: 8px;
//             padding: 10px; /* Reduced padding */
//             margin-bottom: 20px; /* Reduced margin */
//             color: #333;
//             box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Reduced shadow */
//         }

//         .account-details {
//             display: grid;
//             grid-template-columns: 1fr 1fr;
//             gap: 15px; /* Reduced gap */
//             margin-bottom: 20px; /* Reduced margin */
//             background-color: #f1f3f5;
//             padding: 15px; /* Reduced padding */
//             border-radius: 8px;
//         }

//         .account-details div {
//             display: flex;
//             gap: 8px; /* Reduced gap */
//         }

//         .account-details strong {
//             min-width: 120px; /* Reduced width */
//             color: #004C8F;
//         }

//         .table {
//             width: 100%;
//             border-collapse: separate;
//             border-spacing: 0;
//             margin-top: 20px; /* Reduced margin */
//             font-size: 11px; /* Reduced font size */
//             table-layout: fixed; /* Set table layout to fixed */
//         }

//         .table th, .table td {
//             border: 1px solid #e9ecef;
//             padding: 6px; /* Reduced padding */
//             text-align: left;
//             word-wrap: break-word; /* Ensure long words wrap to next line */
//         }

//         .table th {
//             background-color: #004C8F;
//             color: white;
//             font-weight: 500;
//             text-transform: uppercase;
//         }

//         .table tr:nth-child(even) {
//             background-color: #f8f9fa;
//         }

//         .table tr:hover {
//             background-color: #e9ecef;
//         }

//         /* Adjust column widths */
//         .table th:nth-child(1), .table td:nth-child(1) {
//             width: 12%; /* Narrow the Date column */
//         }

//         .table th:nth-child(2), .table td:nth-child(2) {
//             width: 12%; /* Narrow the Sold Amount column */
//         }

//         .table th:nth-child(3), .table td:nth-child(3) {
//             width: 10%; /* Narrow the Received column */
//         }

//         .table th:nth-child(4), .table td:nth-child(4) {
//             width: 10%; /* Narrow the Transfer In column */
//         }

//         .table th:nth-child(5), .table td:nth-child(5) {
//             width: 10%; /* Narrow the Transfer Out column */
//         }

//         .table th:nth-child(6), .table td:nth-child(6) {
//             width: 10%; /* Narrow the Transfer By column */
//         }

//         .table th:nth-child(7), .table td:nth-child(7) {
//             width: 10%; /* Narrow the Transfer To column */
//         }

//         .table th:nth-child(8), .table td:nth-child(8) {
//             width: 10%; /* Narrow the Balance column */
//         }

//         .table th:nth-child(9), .table td:nth-child(9) {
//             width: 10%; /* Narrow the Payment Type column */
//         }

//         .table th:nth-child(10), .table td:nth-child(10) {
//             width: 10%; /* Narrow the Mode column */
//         }

//         .summary-section {
//             margin-top: 20px; /* Reduced margin */
//             background-color: #e9ecef;
//             padding: 15px; /* Reduced padding */
//             border-radius: 8px;
//         }

//         .summary-section strong {
//             color: #004C8F;
//             font-size: 16px; /* Reduced font size */
//             display: block;
//             margin-bottom: 8px; /* Reduced margin */
//         }

//         .footer {
//             margin-top: 20px; /* Reduced margin */
//             font-size: 11px; /* Reduced font size */
//             color: #6c757d;
//             text-align: center;
//             padding: 15px; /* Reduced padding */
//             background-color: #f1f3f5;
//             border-radius: 8px;
//         }

//         .disclaimer {
//             margin-top: 15px; /* Reduced margin */
//             font-size: 11px; /* Reduced font size */
//             font-style: italic;
//             text-align: center;
//             color: #6c757d;
//         }
//     </style>
// </head>
// <body>
//     <div class="container">
//         <div class="page-header">
//             <div class="bank-logo">Kiyo International Payment Statement</div>
//             <div class="page-info">Page No: 1</div>
//         </div>

//         <div class="content">
//             <div class="account-holder-box">
//                 <strong>${clientName}</strong><br>
//                 Account ID: ${paymentData[0]?.accountId || "N/A"}<br>
//                 Branch: Main Branch
//             </div>

//             <div class="account-details">
//                 <div><strong>Account Type:</strong> Regular</div>
//                 <div><strong>Statement Period:</strong> ${new Date().toLocaleDateString()}</div>
//                 <div><strong>Currency:</strong> INR</div>
//                 <div><strong>Generated On:</strong> ${new Date().toLocaleDateString()}</div>
//             </div>

//             <table class="table">
//                 <thead>
//                     <tr>
//                         <th>Date</th>
//                         <th>Sold Amount</th>
//                         <th>Received</th>
//                         <th>Transfer In</th>
//                         <th>Transfer Out</th>
//                         <th>Transfer By</th>
//                         <th>Transfer To</th>
//                         <th>Balance</th>
//                         <th>Payment Type</th>
//                         <th>Mode</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     ${paymentData
//                         .map(
//                             (payment) => `
//                     <tr>
//                         <td>${payment.date}</td>
//                         <td>₹${payment.soldAmount.toFixed(2)}</td>
//                         <td>₹${payment.receivedAmount.toFixed(2)}</td>
//                         <td>₹${payment.transferIn.toFixed(2)}</td>
//                         <td>₹${payment.transferOut.toFixed(2)}</td>
//                         <td>${payment.sentBy || "NA"}</td>
//                         <td>${payment.sentTo || 'NA'}</td>
//                         <td>₹${payment.currentBalance.toFixed(2)}</td>
//                         <td>${payment.orderPaymentType}</td>
//                         <td>${payment.paymentMode || 'N/A'}</td>
//                     </tr>`
//                         )
//                         .join('')}
//                 </tbody>
//             </table>

//             <div class="summary-section">
//                 <strong>STATEMENT SUMMARY</strong>
//                 <div>Opening Balance: ₹${paymentData[0]?.currentBalance.toFixed(2) || "0.00"}</div>
//                 <div>Total Credits: ${paymentData.filter((p) => p.transferIn > 0).length}</div>
//                 <div>Total Debits: ${paymentData.filter((p) => p.transferOut > 0).length}</div>
//                 <div>Closing Balance: ₹${paymentData[paymentData.length - 1]?.currentBalance.toFixed(2) || "0.00"}</div>
//             </div>

//             <div class="disclaimer">
//                 This is a computer-generated statement and does not require a signature.
//             </div>

//             <div class="footer">
//                 For any queries, please contact our customer support at support@myapp.com<br>
//                 MyApp Financial Services Ltd. | Registered Office: Financial District, City - 500032
//             </div>
//         </div>
//     </div>
// </body>
// </html>

//       `;
